export default "__VITE_ASSET__1iSeWLi1__"